module.exports = __webpack_public_path__ + "static/media/s-bahn.13c5a948.svg";